import { useCallback } from 'react';
import { useAppUpdatesContext } from '@app/app/src/AppContext';
import { useUrlFilterSync } from '@app/app-updates-table-filters';

export const usePagination = () => {
  const { dispatch } = useAppUpdatesContext();
  const { syncFiltersToUrl } = useUrlFilterSync();

  const setCursor = useCallback(
    (cursor: string | undefined) => {
      dispatch({
        type: 'UPDATES_CURSOR_SET',
        payload: { cursor },
      });
      syncFiltersToUrl({ cursor });
    },
    [dispatch, syncFiltersToUrl],
  );

  const setLimit = useCallback(
    (limit: number) => {
      dispatch({
        type: 'UPDATES_LIMIT_SET',
        payload: { limit },
      });
      syncFiltersToUrl({ cursor: undefined, limit });
    },
    [dispatch, syncFiltersToUrl],
  );

  return {
    setCursor,
    setLimit,
  };
};
